/**
 * Cookie preferences plugin
 * Checks for user's cookie preferences and disables GTM tracking if opted out
 */
const COOKIES_OPT_OUT_COOKIE_NAME = "cookies-opted-out";

export default defineNuxtPlugin({
  name: "cookie-preferences",
  enforce: "pre",
  setup() {
    // Check if user has opted out from cookies
    const checkCookieOptOut = () => {
      if (typeof window !== "undefined") {
        const hasOptedOut = document.cookie.split(";").some(c => c.trim().startsWith(`${COOKIES_OPT_OUT_COOKIE_NAME}=true`));
        const config = useRuntimeConfig();
        config.public.gtm.enabled = !hasOptedOut;
        return hasOptedOut;
      }

      return false;
    };

    const optOut = () => {
      document.cookie = `${COOKIES_OPT_OUT_COOKIE_NAME}=true; path=/; max-age=31536000`;
      const config = useRuntimeConfig();
      config.public.gtm.enabled = false;
    };

    const optIn = () => {
      document.cookie = `${COOKIES_OPT_OUT_COOKIE_NAME}=false; path=/; max-age=0`;
      const config = useRuntimeConfig();
      config.public.gtm.enabled = true;
    };

    // Add to global properties
    return {
      provide: {
        cookiePreferences: {
          checkCookieOptOut,
          isOptedOut: checkCookieOptOut(),
          optOut,
          optIn
        }
      }
    };
  }
});